import { cmsLinkParser, LinkResponse } from '../cmsLink/cmsLink.parser'
import { Actions } from './actions.state'

export type ActionsResponse = {
  actions?: { primaryAction?: LinkResponse; secondaryAction?: LinkResponse; showActionAsLink: boolean }
}

export const actionsParser = ({ actions }: ActionsResponse): Actions => ({
  primaryAction: cmsLinkParser(actions?.primaryAction),
  secondaryAction: cmsLinkParser(actions?.secondaryAction),
  showActionAsLink: actions?.showActionAsLink || false,
})
